import type { Role } from '../data/types';

/** The role as people read it ("Store team", never the stored "StoreTeam" — UI review U11). */
export function roleLabel(role: Role | string | undefined | null): string {
  if (!role) return '';
  return role === 'StoreTeam' ? 'Store team' : role;
}
